<template>
  <div class="intro-content">
    <v-container>
      <!-- Page 1 -->
      <h1>{{ head1 }} <span class="dod"></span></h1>
      <p>{{ text1 }}</p>

      <!-- Page 4 -->
      <!-- <h2 style="text-align:left;">{{ head4 }}</h2> -->
      <h3 style="text-align:left;">{{ subhead4_1 }}</h3>
      <p class="indented1">{{ text4_1 }}</p>
      <p class="indented2">
        <span class="bold">{{ text4_1word1 }}</span>
        &nbsp;{{ text4_1define1 }}
      </p>
      <p class="indented2">
        <span class="bold">{{ text4_1word2 }}</span>
        &nbsp;{{ text4_1define2 }}
      </p>
      <p class="indented2">
        <span class="bold">{{ text4_1word3 }}</span>
        &nbsp;{{ text4_1define3 }}
      </p>
      <p class="indented2under">{{ text4_1word3_under1 }}</p>
      <p class="indented2underSubitem">{{ text4_1word3_under1a }}</p>
      <p class="indented2underSubitem">{{ text4_1word3_under1b }}</p>
      <ul class="indented2">
        <li>{{ text4_1define3list1_1 }}</li>
        <li>{{ text4_1define3list1_2 }}</li>
        <li>{{ text4_1define3list1_3 }}</li>
      </ul>

      <h3 style="text-align:left;">{{ subhead4_1b_dod }}</h3>
      <p class="indented1">{{ text4_1b_dod_1 }}&nbsp;<strong>{{ text4_1b_dod_1word1 }}</strong>:</p>
      <p class="indented2"><strong>{{ text4_1b_dod_2_head }}</strong>{{ text4_1b_dod_2 }}</p>
			<p class="indented2"><strong>{{ text4_1b_dod_3_head }}</strong>{{ text4_1b_dod_3 }}</p>
			<p class="indented1">{{ text4_1b_dod_4 }}: <a href="http://comptroller.defense.gov/Portals/45/documents/fmr/Volume_02b.pdf" target="_blank">{{ text4_1b_dod_3_linktext }}</a>.
			</p>
      <h3 style="text-align:left;">{{ subhead4_2 }}</h3>
      <p class="indented1">{{ text4_2_1 }}</p>
      <p class="indented1">{{ text4_2_2 }}</p>
      <p class="indented1">{{ text4_2_3 }}</p>

      <!-- Page 3 -->
      <v-layout row wrap>

          <h3 style="text-align:left">
            {{ head3_1 }}
            <br />
            <div class="normal">{{ head3_1source }}</div>
          </h3>
          <ul>
            <li class="indented2">
              <span class="bold">{{ list3_1_1word }}: </span>
              {{ list3_1_1define }}
            </li>
            <li class="indented2">
              <span class="bold">{{ list3_1_2word }}: </span>
              {{ list3_1_2define }}
            </li>
            <li class="indented2">
              <span class="bold">{{ list3_1_3word }}: </span>
              {{ list3_1_3define }}
            </li>
            <li class="indented2">
              <span class="bold">{{ list3_1_4word }}: </span>
              {{ list3_1_4define }}
            </li>
            <li class="indented2">
              <span class="bold">{{ list3_1_5word }}: </span>
              {{ list3_1_5define }}
            </li>
          </ul>

          <h3 style="text-align:left">
            {{ head3_2 }}
          </h3>
          <ul>
            <li class="indented2">{{ list3_2_1 }}</li>
            <li class="indented2">{{ list3_2_2 }}</li>
            <li class="indented2">{{ list3_2_3 }}</li>
            <li class="indented2">{{ list3_2_4 }}</li>
            <li class="indented2">{{ list3_2_5 }}</li>
            <li class="indented2">{{ list3_2_6 }}</li>
            <li class="indented2">{{ list3_2_7 }}</li>
            <li class="indented2">{{ list3_2_8 }}</li>
            <li class="indented2">{{ list3_2_9 }}</li>
            <li class="indented2">{{ list3_2_10 }}</li>
            <li class="indented2">{{ list3_2_11 }}</li>
            <li class="indented2">{{ list3_2_12 }}</li>
          </ul>

      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  data () {
    return {
      head1: "General Survey Definitions and Instructions",
      text1:
        "The following section provides general guidance on what should be reported on the survey. These definitions come from OMB Circular A-11, Section 84.2(c). Additional definitions and other instructions are provided throughout the questionnaire as needed.",

      head3_1: "R&D Activities Must Be...",
      head3_1source: "(Source: Frascati Manual 2015)",
      list3_1_1word: "Novel",
      list3_1_2word: "Creative",
      list3_1_3word: "Uncertain",
      list3_1_4word: "Systematic",
      list3_1_5word: "Transferable/Reproducible",
      list3_1_1define:
        "projects that advance current knowledge or create new knowledge",
      list3_1_2define: "projects focused on original concepts and hypotheses",
      list3_1_3define:
        "project outcomes are unable to be completely determined at the outset",
      list3_1_4define: "projects are planned and budgeted",
      list3_1_5define:
        "project methodology and results are transferable/reproducible to other situations and locations",
      head3_2: "Types of Activities Not Likely To Be R&D",
      list3_2_1: "Program planning and evaluation (unless part of an existing R&D program)",
      list3_2_2:
        "Commercialization (includes promoting/producing the products/services from R&D projects)",
      list3_2_3: "Economic/policy/feasibility studies",
      list3_2_4: "General patient services",
      list3_2_5: "Information systems",
      list3_2_6: "Management studies",
      list3_2_7: "Marketing of products/services",
      list3_2_8: "Market research or analysis",
      list3_2_9: "Routine data collection/dissemination",
      list3_2_10: "Routine monitoring/testing",
      list3_2_11: "Strategic planning",
      list3_2_12: "Technology transfer",

      head4: "What is R&D? ",
      subhead4_1: "R&D Conduct (budget activities 1–6)",
      text4_1:
        "Research and experimental development (R&D) conduct is defined as creative and systematic work undertaken in order to increase the stock of knowledge—including knowledge of people, culture, and society—and to devise new applications using available knowledge.",
      text4_1word1: "Basic research:",
      text4_1define1:
        "Basic research is defined as experimental or theoretical work undertaken primarily to acquire new knowledge of the underlying foundations of phenomena and observable facts. Basic research may include activities with broad or general applications in mind, such as the study of how plant genomes change, but should exclude research directed towards a specific application or requirement, such as the optimization of the genome of a specific crop species. Basic research represents Department of Defense budget activity 1.",
      text4_1word2: "Applied research:",
      text4_1define2:
        "Applied research is defined as original investigation undertaken in order to acquire new knowledge. Applied research is, however, directed primarily towards a specific practical aim or objective. Applied research represents Department of Defense budget activity 2.",
      text4_1word3: "Experimental development:",
      text4_1define3:
        "Experimental development is defined as creative and systematic work, drawing on knowledge gained from research and practical experience, which is directed at producing new products or processes or improving existing products or processes. Like research, experimental development will result in gaining additional knowledge. (More details about what is included and excluded can be found in question 5).",
      text4_1word3_under1: "For DOD agencies, experimental development includes:",
      text4_1word3_under1a: "Advanced technology development (ATD) (budget activity 3)",
      text4_1word3_under1b: "Major systems development (budget activities 4–6), consisting of:",
      text4_1define3list1_1:
        "Advanced component development and prototypes (ACD&P) (budget activity 4)",
      text4_1define3list1_2:
        "System development and demonstration (SDD) (budget activity 5)",
      text4_1define3list1_3:
        "RDT&E management support (budget activity 6)",
      text4_1define3list2_1:
        "User demonstrations where the cost and benefits of a system are being validated for a specific use case. This includes low-rate initial production activities.",
      text4_1define3list2_2:
        "Pre-production development, which is defined as non-experimental work on a product or system before it goes into full production, including activities such as tooling and development of production facilities. For example, exclude activities and programs that are categorized as “operational systems development” in DOD’s budget activity structure. Activities and programs of this type should generally be reported as investments in other major equipment. ",

      subhead4_1b_dod: "RDT&E (budget activities 1–8)",
      text4_1b_dod_1: "Research, development, test, and evaluation (RDT&E) consists of all the activities described above for R&D conduct",
      text4_1b_dod_1word1: "plus",
			text4_1b_dod_2_head: "Operational system development (budget activity 7)",
      text4_1b_dod_2: " : pre-production development of non-experimental work on a product or system before it goes into full production, including activities such as tooling and development of production facilities.",
			text4_1b_dod_3_head: "Software and digital technology pilot programs (budget activity 8)",
			text4_1b_dod_3: " : software, electronic tools, systems, applications, resources, acquisition of services, business process re-engineering activities, functional requirements development, technical evaluations, and other activities in direct support of acquiring, developing, deploying, sustaining, enhancing, and modernizing Software Digital Technology Pilot Programs.",
      text4_1b_dod_4: "For DOD agencies, definitions are established by Department of Defense Instruction 5000.02 \"Operation of the Defense Acquisition System.\" For more information, see Budget Activities 1 through 8 in the DOD Financial Management Regulation (FMR), Volume 2B, Chapter 5, at",
      text4_1b_dod_3_linktext: "https://comptroller.defense.gov/Portals/45/documents/fmr/current/02b/02b_05.pdf",

      subhead4_2: "R&D Plant",
      text4_2_1:
        "R&D plant includes spending on both R&D facilities and major equipment as defined in Office of Management and Budget (OMB) Circular A-11, Section 84 (Schedule C) and includes physical assets, such as land, structures, equipment, and intellectual property (e.g., software or applications) that have an estimated useful life of two years or more; or commodity inventories.",
      text4_2_2:
        "Reporting for R&D plant includes the purchase, construction, manufacture, rehabilitation, or major improvement of physical assets regardless of whether the assets are owned or operated by the Federal Government, States, municipalities, or private individuals. The cost of the asset includes both its purchase price and all other costs incurred to bring it to a form and location for its intended use. ",
      text4_2_3:
        "Obligations for foreign R&D plant are limited to federal funds for facilities that are located abroad and used in support of foreign R&D."

    };
  }
};
</script>

<style scoped>
h1 {
  font-size: 22pt; /*TODO learn how to share via default_intros.css */
  font-weight: bold;
  margin-bottom: 12pt;
  margin-top: 12pt;
}
h2 {
  font-size: 20pt; /*TODO learn how to share via default_intros.css */
  font-weight: bold;
  margin-bottom: 12pt;
  margin-top: 12pt;
}
h3 {
  font-size: 18pt;
  font-weight: bold;
  margin-left: 12pt;
}
.indented1 {
  margin-left: 25pt;
  font-weight: normal;
}
.indented2 {
  margin-left: 50pt;
  font-weight: normal;
}
.indented2under {
  margin-left: 60pt;
  font-weight: normal;
  text-decoration-line: underline;
}
.indented2underSubitem {
  margin-left: 60pt;
  font-weight: normal;
}
.bold {
  font-weight: bold;
}
.italics {
  font-style: italic;
}
.normal {
  font-size: .75em;
  font-weight: normal;
}
.listhead {
  text-align: left;
  text-decoration-line: underline;
  font-size: larger;
  margin-bottom: 10pt;
}
.left {
  text-align: left;
}
.centered {
  text-align: center;
}
ul,
p {
  text-align: left;
}
p,
li {
  font-size: 12pt;
}
li {
  margin-left: 25pt;
  margin-bottom: 5pt;
}
.intro-content {
  color: #000;
  max-width: 750px; /* TODO: discuss w/team; make a global */
}
.bordered {
  border: #000;
  border: 1px solid;
}
.header {
  font-weight: bold;
  color: #13314f;
  font-size: 14px;
  margin: 0;
}
table {
  background-color: aliceblue;
  width: 100%;
  text-align: left;
  border-spacing: 0;
  border: 1px solid black;
  border-collapse: collapse;
}
th {
  text-align: center;
  border: 1px solid black;
  padding: 15px;
}
.marginleft {
  margin-left: 5px;
}
td {
  border: 1px solid black;
  padding: 10px;
}
td.center {
  text-align: center;
  border: 1px solid black;
}
</style>
